/**
 * Clerk runtime source for the BROWSER (swapped in for
 * `clerk-runtime-source.ts` by `clientOverrides` in vite.config.ts).
 *
 * The runtime (Clerk SDK + Convex-with-Clerk + user sync) is a separate chunk.
 * `prepareClientRuntime()` (src/client.tsx) awaits {@link loadClerkRuntime}
 * BEFORE hydration whenever the server rendered the page with Clerk, so
 * `getClerkRuntime()` is synchronous during hydration and the tree matches the
 * SSR markup exactly. Anonymous visitors never request the chunk.
 */
import type { ClerkRuntime } from './clerk-runtime'

export type ClerkRuntimeComponent = typeof ClerkRuntime

let runtime: ClerkRuntimeComponent | null = null

export function getClerkRuntime(): ClerkRuntimeComponent | null {
  return runtime
}

export async function loadClerkRuntime(): Promise<void> {
  if (runtime) return
  runtime = (await import('./clerk-runtime')).ClerkRuntime
}
